"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AISuggestionsComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const ai_suggestions_component_types_1 = require("./types/ai-suggestions.component.types");
const SignalService_1 = __importStar(require("@front/services/SignalService"));
const assistant_component_types_1 = require("../ai-assist/types/assistant.component.types");
//@ts-ignore                
let rwsTemplate = T.html `<div class="ai-suggestions-container">
    <div class="suggestions-header">
        <div class="header-content">
            <h3>${'ai.suggestions.title'.t()}</h3>
            <div class="header-actions">
                ${(0, fast_element_1.when)(x => x.suggestions.length > 1, (0, fast_element_1.html) `
                    <button class="btn btn-sm btn-outline" @click="${x => x.selectAll()}" 
                            ?disabled="${x => x.selectedSuggestions.length === x.suggestions.length}">
                        ${'trainer.upload.pdf.chapters.selectall'.t()}
                    </button>
                    <button class="btn btn-sm btn-outline" @click="${x => x.clearAll()}"
                            ?disabled="${x => x.selectedSuggestions.length === 0}">
                        ${'trainer.upload.pdf.chapters.deselectall'.t()}
                    </button>
                `)}
            </div>
        </div>
        ${(0, fast_element_1.when)(x => { var _a; return x.contextPreview && !((_a = x.suggestionsContext) === null || _a === void 0 ? void 0 : _a.isFromInput); }, (0, fast_element_1.html) `
            <div class="context-preview">
                <span class="context-label">${x => { var _a; return ((_a = x.suggestionsContext) === null || _a === void 0 ? void 0 : _a.isFromInput) ? 'ai.suggestions.context.prompt'.t() : 'ai.suggestions.context.message'.t(); }}:</span>
                <span class="context-text">${x => x.truncateText(x.contextPreview, 80)}</span>
            </div>
        `)}        
    </div>

    <div class="suggestions-content">
        <div class="suggestions-list">
            ${(0, fast_element_1.repeat)(x => x.allSuggestions, (0, fast_element_1.html) `
                <div class="suggestion-item ${(x, c) => c.parent.isSelected(x) ? 'selected' : ''} ${(x, c) => c.parent.isClarificationSuggestion(x) ? 'clarification-suggestion' : ''}" 
                     @click="${(x, c) => c.parent.toggleSuggestion(x)}">
                    ${(0, fast_element_1.when)(x => x.id === 'clarification-input', (0, fast_element_1.html) `
                        <div class="suggestion-header">
                            <i class="simple-icon-pencil suggestion-icon"></i>
                            <h4 class="suggestion-title">${x => x.title}</h4>
                        </div>
                        <div class="clarification-content">
                            <textarea 
                                id="clarification-input"
                                class="clarification-input"
                                :value="${(x, c) => c.parent.clarificationText}"
                                @input="${(x, c) => c.parent.clarificationText = c.event.target.value}"
                                @click="${(x, c) => c.event.stopPropagation()}"
                                placeholder="${'ai.suggestions.clarification.placeholder'.t()}"
                                rows="3">
                            </textarea>
                        </div>
                    `, (0, fast_element_1.html) `
                        <div class="suggestion-header">
                            ${(0, fast_element_1.when)(x => x.context === 'kdb_attachment', (0, fast_element_1.html) `<i class="simple-icon-paper-clip suggestion-icon"></i>`, (0, fast_element_1.html) `<i class="simple-icon-bulb suggestion-icon"></i>`)}                            
                            <h4 class="suggestion-title">${x => x.title}</h4>
                            <div class="suggestion-check ${(x, c) => c.parent.isSelected(x) ? 'visible' : ''}">
                                <i class="simple-icon-check"></i>
                            </div>
                        </div>
                        ${(0, fast_element_1.when)(x => x.kdb, (0, fast_element_1.html) `<div class="suggestion-preview">
                                <span class="kdb-entry-title">${x => x.kdb.title}</span>   
                                <span class="kdb-entry-file">${x => (x.kdb.file.size / 1024 / 1024).toFixed(2)} MB (${x => x.kdb.file.mimeType.split('/').pop()})</span>                      
                            </div>`, (0, fast_element_1.html) `<p class="suggestion-description">${x => x.description}</p>
                                 <div class="suggestion-preview">${x => x.text}</div>`)}
                    `)}
                </div>
            `)}
        </div>
    </div>

    <div class="suggestions-footer">
        <button class="btn btn-secondary" @click="${x => x.close()}">
            <i class="simple-icon-close"></i>
            ${'common.cancel'.t()}
        </button>
        <button class="btn btn-primary" 
                @click="${x => x.applySuggestions()}"
                ?disabled="${x => x.selectedSuggestions.length === 0}">
            <i class="simple-icon-check"></i>
            ${'ai.suggestions.apply'.t()} ${x => x.selectedSuggestions.length > 0 ? `(${x.selectedSuggestions.length})` : ''}
        </button>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
  height: 100%;
  outline: none;
}

.ai-suggestions-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: var(--bg-white, #fff);
  border-radius: 8px;
  overflow: hidden;
}
.ai-suggestions-container .suggestions-header {
  padding: 1.5rem;
  border-bottom: 1px solid var(--border-color, #e0e0e0);
  background: var(--bg-white, #fff);
  flex-shrink: 0;
}
.ai-suggestions-container .suggestions-header .header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}
.ai-suggestions-container .suggestions-header .header-content .header-actions {
  display: flex;
  gap: 0.5rem;
}
.ai-suggestions-container .suggestions-header .header-content .header-actions .btn-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.8rem;
}
.ai-suggestions-container .suggestions-header .header-content .header-actions .btn-outline {
  border: 1px solid var(--border-color, #e0e0e0);
  background: transparent;
  color: var(--text-primary, #333);
}
.ai-suggestions-container .suggestions-header .header-content .header-actions .btn-outline:hover:not(:disabled) {
  border-color: var(--primary-color, #4f46e5);
  color: var(--primary-color, #4f46e5);
}
.ai-suggestions-container .suggestions-header .header-content .header-actions .btn-outline:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ai-suggestions-container .suggestions-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary, #333);
}
.ai-suggestions-container .suggestions-header .suggestions-description {
  color: var(--text-muted, #666);
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.4;
}
.ai-suggestions-container .suggestions-header .suggestions-description .selection-count {
  display: inline-block;
  margin-left: 0.5rem;
  padding: 0.25rem 0.5rem;
  background: var(--primary-color, #4f46e5);
  color: white;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
}
.ai-suggestions-container .suggestions-header .context-preview {
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: var(--bg-light, #f8f9fa);
  border-radius: 6px;
  border-left: 3px solid var(--primary-color, #4f46e5);
}
.ai-suggestions-container .suggestions-header .context-preview .context-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-primary, #333);
  margin-right: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.ai-suggestions-container .suggestions-header .context-preview .context-text {
  font-size: 0.85rem;
  color: var(--text-muted, #666);
  font-style: italic;
  line-height: 1.3;
  display: inline;
  word-break: break-word;
}
.ai-suggestions-container .suggestions-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.ai-suggestions-container .suggestions-content .suggestions-list {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item {
  border: 2px solid var(--border-color, #e0e0e0);
  border-radius: 8px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(0, 0, 0, 0.03);
  flex-shrink: 0;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item:hover:not(.selected) {
  border-color: var(--primary-color, #4f46e5);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.1);
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.selected {
  border-color: var(--primary-color, #4f46e5) !important;
  background: #f0fff9 !important;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.1) !important;
  transform: translateY(-2px);
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.selected:hover {
  border-color: var(--primary-color, #4f46e5) !important;
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.25) !important;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item .suggestion-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item .suggestion-header .suggestion-icon {
  color: var(--warning-color, #f59e0b);
  font-size: 1.1rem;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item .suggestion-header .suggestion-title {
  flex: 1;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary, #333);
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item .suggestion-header .suggestion-check {
  color: var(--success-color, #10b981);
  font-size: 1rem;
  opacity: 0;
  transition: opacity 0.2s ease;
  min-width: 16px;
  text-align: center;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item .suggestion-header .suggestion-check.visible {
  opacity: 1 !important;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.selected .suggestion-check {
  opacity: 1;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item .suggestion-description {
  color: var(--text-muted, #666);
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
  line-height: 1.4;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item .suggestion-preview {
  background: var(--bg-gray-light, #f8f9fa);
  border: 1px solid var(--border-light, #e9ecef);
  border-radius: 4px;
  padding: 0.75rem;
  font-size: 0.875rem;
  color: var(--text-secondary, #555);
  font-family: "Courier New", monospace;
  white-space: pre-wrap;
  max-height: 100px;
  overflow-y: auto;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item .suggestion-preview .kdb-entry-title {
  font-weight: 700;
  display: block;
  margin-bottom: 0.25rem;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item .suggestion-preview .kdb-entry-file {
  font-size: 0.75rem;
  color: var(--text-muted, #666);
  margin: 0;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion {
  border-color: var(--primary-color, #4f46e5) !important;
  background: var(--bg-light, #f8f9fa) !important;
  cursor: default !important;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion:hover {
  border-color: var(--primary-color, #4f46e5) !important;
  background: var(--bg-light, #f8f9fa) !important;
  transform: none !important;
  box-shadow: none !important;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion.selected {
  border-color: var(--primary-color, #4f46e5) !important;
  background: var(--bg-light, #f8f9fa) !important;
  box-shadow: none !important;
  transform: none !important;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion.selected:hover {
  border-color: var(--primary-color, #4f46e5) !important;
  background: var(--bg-light, #f8f9fa) !important;
  box-shadow: none !important;
  transform: none !important;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion .suggestion-header .suggestion-icon {
  color: var(--primary-color, #4f46e5);
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion .suggestion-header .suggestion-check {
  display: none !important;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion .clarification-content {
  margin-top: 0.75rem;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion .clarification-content .clarification-input {
  width: 100%;
  min-height: 80px;
  padding: 0.75rem;
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 6px;
  font-family: inherit;
  font-size: 0.9rem;
  line-height: 1.4;
  background: var(--bg-white, #fff);
  color: var(--text-primary, #333);
  resize: vertical;
  transition: border-color 0.2s ease;
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion .clarification-content .clarification-input:focus {
  outline: none;
  border-color: var(--primary-color, #4f46e5);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}
.ai-suggestions-container .suggestions-content .suggestions-list .suggestion-item.clarification-suggestion .clarification-content .clarification-input::placeholder {
  color: var(--text-muted, #999);
  font-style: italic;
}
.ai-suggestions-container .suggestions-content .clarification-section {
  padding: 1rem;
  border-top: 1px solid var(--border-color, #e0e0e0);
  background: var(--bg-gray-light, #f8f9fa);
  flex-shrink: 0;
}
.ai-suggestions-container .suggestions-content .clarification-section .clarification-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: var(--text-primary, #333);
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}
.ai-suggestions-container .suggestions-content .clarification-section .clarification-label i {
  color: var(--primary-color, #4f46e5);
}
.ai-suggestions-container .suggestions-content .clarification-section .clarification-input {
  width: 100%;
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 4px;
  padding: 0.75rem;
  font-size: 0.875rem;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s ease;
  min-height: 80px;
  max-height: 120px;
}
.ai-suggestions-container .suggestions-content .clarification-section .clarification-input:focus {
  outline: none;
  border-color: var(--primary-color, #4f46e5);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}
.ai-suggestions-container .suggestions-content .clarification-section .clarification-input::placeholder {
  color: var(--text-muted, #999);
}
.ai-suggestions-container .suggestions-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-color, #e0e0e0);
  background: var(--bg-white, #fff);
  flex-shrink: 0;
}
.ai-suggestions-container .suggestions-footer .btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}
.ai-suggestions-container .suggestions-footer .btn.btn-secondary {
  background: var(--bg-gray, #f5f5f5);
  color: var(--text-secondary, #666);
}
.ai-suggestions-container .suggestions-footer .btn.btn-secondary:hover {
  background: var(--bg-gray-dark, #e0e0e0);
  color: var(--text-primary, #333);
}
.ai-suggestions-container .suggestions-footer .btn.btn-primary {
  background: var(--primary-color, #4f46e5);
  color: white;
}
.ai-suggestions-container .suggestions-footer .btn.btn-primary:hover:not(:disabled) {
  background: var(--primary-dark, #4338ca);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}
.ai-suggestions-container .suggestions-footer .btn.btn-primary:disabled {
  background: var(--bg-gray, #d1d5db);
  color: var(--text-muted, #9ca3af);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.ai-suggestions-container .suggestions-footer .btn i {
  font-size: 0.875rem;
}`;
const shadowOptions = { "mode": "open" };
let AISuggestionsComponent = class AISuggestionsComponent extends client_1.RWSViewComponent {
    constructor(signalService) {
        super();
        this.signalService = signalService;
        this.suggestions = [];
        this.selectedSuggestions = [];
        this.clarificationText = '';
        this.contextPreview = '';
        this.suggestionsContext = null;
        this.assistantSignal = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.assistantSignal = this.signalService.getSignal('ai.assist', { initialValue: null });
        // Add ESC key listener
        this.addEventListener('keydown', this.handleKeyDown.bind(this));
        // Make the component focusable so it can receive keyboard events
        this.tabIndex = -1;
        this.focus();
        // Update context preview when context changes
        this.updateContextPreview();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('keydown', this.handleKeyDown.bind(this));
    }
    suggestionsContextChanged() {
        this.updateContextPreview();
    }
    updateContextPreview() {
        if (!this.suggestionsContext) {
            this.contextPreview = '';
            return;
        }
        const { lastMessage, inputPrompt, isFromInput } = this.suggestionsContext;
        if (isFromInput && inputPrompt) {
            this.contextPreview = inputPrompt;
        }
        else if (lastMessage) {
            this.contextPreview = lastMessage;
        }
        else {
            this.contextPreview = '';
        }
    }
    truncateText(text, maxLength = 100) {
        if (!text)
            return '';
        if (text.length <= maxLength)
            return text;
        return text.substring(0, maxLength) + '...';
    }
    get allSuggestions() {
        const baseSuggestions = [...this.suggestions];
        // Add clarification as the last suggestion
        const clarificationSuggestion = {
            id: 'clarification-input',
            title: 'ai.suggestions.clarification.label'.t(),
            description: 'ai.suggestions.clarification.placeholder'.t(),
            text: this.clarificationText || '',
            context: 'clarification',
            selected: false
        };
        return [...baseSuggestions, clarificationSuggestion];
    }
    isClarificationSuggestion(suggestion) {
        return suggestion.id === 'clarification-input';
    }
    handleKeyDown(event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.close();
        }
    }
    suggestionsChanged(oldValue, newValue) {
        // Reset selections when suggestions change
        this.selectedSuggestions = [];
        this.clarificationText = '';
        // Ensure all suggestions have the selected property initialized
        if (newValue && newValue.length > 0) {
            newValue.forEach(suggestion => {
                if (suggestion.selected === undefined) {
                    suggestion.selected = false;
                }
            });
        }
    }
    toggleSuggestion(suggestion) {
        // Handle clarification suggestion differently - it's not selectable
        if (this.isClarificationSuggestion(suggestion)) {
            // Focus the clarification input instead
            const clarificationInput = this.querySelector('#clarification-input');
            if (clarificationInput) {
                clarificationInput.focus();
            }
            return;
        }
        const index = this.selectedSuggestions.findIndex(s => s.id === suggestion.id);
        if (index > -1) {
            // Remove from selection
            this.selectedSuggestions = this.selectedSuggestions.filter(s => s.id !== suggestion.id);
            suggestion.selected = false;
        }
        else {
            // Add to selection
            this.selectedSuggestions = [...this.selectedSuggestions, suggestion];
            suggestion.selected = true;
        }
        // No need to force update - the selectedSuggestions array change will trigger reactivity
    }
    isSelected(suggestion) {
        // Clarification suggestion is never "selected" in the traditional sense
        if (this.isClarificationSuggestion(suggestion)) {
            return false;
        }
        return this.selectedSuggestions.some(s => s.id === suggestion.id);
    }
    applySuggestions() {
        var _a;
        if (this.selectedSuggestions.length === 0) {
            return;
        }
        // Separate suggestions by type
        const textSuggestions = [];
        const kdbSuggestions = [];
        for (const suggestion of this.selectedSuggestions) {
            if (suggestion.context === assistant_component_types_1.AssistantActionContext.KDB_ATTACHMENT) {
                kdbSuggestions.push(suggestion);
            }
            else if (suggestion.context === assistant_component_types_1.AssistantActionContext.TEXT_INSERTION) {
                textSuggestions.push(suggestion);
            }
        }
        // Handle KDB attachments individually (using the old event for backwards compatibility)
        for (const suggestion of kdbSuggestions) {
            this.$emit('suggestion-applied', {
                suggestion: suggestion,
                text: suggestion.text,
                clarification: this.clarificationText
            });
        }
        // Handle ALL text suggestions through the new event (whether single or multiple)
        if (textSuggestions.length > 0) {
            // Combine all text suggestions with newlines
            const combinedTexts = textSuggestions.map(suggestion => {
                let finalText = suggestion.text;
                // If clarification text is provided, add it to the last suggestion only
                if (this.clarificationText.trim() && suggestion === textSuggestions[textSuggestions.length - 1]) {
                    finalText = `${suggestion.text}\n\n${'ai.suggestions.clarification'.t()}: ${this.clarificationText}`;
                }
                return finalText;
            });
            const combinedText = combinedTexts.join('\n');
            // Emit the new event for all text suggestions (single or multiple)
            this.$emit('suggestions-applied', {
                suggestions: textSuggestions,
                text: combinedText,
                clarification: this.clarificationText,
                isMultiple: textSuggestions.length > 1
            });
        }
        (_a = this.assistantSignal) === null || _a === void 0 ? void 0 : _a.setValue({
            command: assistant_component_types_1.AssistantSignalCommand.MINIMIZE,
        });
    }
    close() {
        this.clearSelection();
        this.$emit('modal-close');
    }
    clearSelection() {
        this.selectedSuggestions = [];
        this.clarificationText = '';
        // Reset selected state on all suggestions
        this.suggestions.forEach(suggestion => {
            suggestion.selected = false;
        });
    }
    selectAll() {
        // Only select non-clarification suggestions
        const selectableSuggestions = this.suggestions.filter(s => !this.isClarificationSuggestion(s));
        this.selectedSuggestions = [...selectableSuggestions];
        selectableSuggestions.forEach(suggestion => {
            suggestion.selected = true;
        });
    }
    clearAll() {
        this.clearSelection();
    }
};
exports.AISuggestionsComponent = AISuggestionsComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AISuggestionsComponent.prototype, "suggestions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AISuggestionsComponent.prototype, "selectedSuggestions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AISuggestionsComponent.prototype, "clarificationText", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AISuggestionsComponent.prototype, "contextPreview", void 0);
__decorate([
    client_1.externalAttr,
    __metadata("design:type", typeof (_b = typeof ai_suggestions_component_types_1.IAISuggestionsContext !== "undefined" && ai_suggestions_component_types_1.IAISuggestionsContext) === "function" ? _b : Object)
], AISuggestionsComponent.prototype, "suggestionsContext", void 0);
exports.AISuggestionsComponent = AISuggestionsComponent = __decorate([
    (0, client_1.RWSView)('ai-suggestions', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(SignalService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _a : Object])
], AISuggestionsComponent);
AISuggestionsComponent.defineComponent();
